module.exports = __webpack_public_path__ + "images/questions/qa_good_question_9d80de044118fdc788912a209799340f.png";